import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'cut', // USEREMO QUESTO NOME NEL DOM
    pure: false
})
export class Cut implements PipeTransform {
    transform(value: any, lunghezza: any) {
        if (value.length > lunghezza) {
            return value.substr(0, lunghezza) + '...';
        } else {
            return value;
        }
    }
}